<template>
  <CustomModal id="series-edit-modal"
               class="basic-modal series-edit-modal"
               v-bind:ok-disabled="saveDisabled"
               v-bind:ok-busy="busy"
               v-bind:ok-title="$t('common.save')"
               v-on:cancel="$emit('cancel')"
               v-on:ok="save()">
    <div class="series-edit-modal__title" slot="modal-header">
      {{ $t('publishers.modal.series_edit.title') }}
    </div>

    <div class="text-center" v-if="loading">
      <LoadingBounce></LoadingBounce>
      <div class="typography--body-2 typography--color-disabled pb-5">
        {{ $t('common.loading') }}
      </div>
    </div>

    <div class="series-edit-modal__form" v-else>
      <div class="form-group">
        <label for="series-title-input"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.new_series.name') }}
        </label>
        <input 
          type="text"
          id="series-title-input"
          class="form-control"
          v-bind:placeholder="$t('publishers.modal.new_series.name_placeholder')"
          v-model="seriesTitle"
        >
      </div>

      <div class="form-group">
        <label for="series-price-input"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.series_edit.price') }}
        </label>
        <input 
          type="number"
          id="series-price-input"
          class="form-control"
          step="1000"
          min="0"
          v-bind:placeholder="$t('publishers.modal.series_edit.price_placeholder')"
          v-model="seriesPrice"
        >
      </div>

      <div class="form-group">
        <label for="series-card-price-input"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.series_edit.card_price') }}
        </label>
        <input 
          type="number"
          id="series-card-price-input"
          class="form-control"
          step="100"
          min="0"
          v-bind:placeholder="$t('publishers.modal.series_edit.card_price_placeholder')"
          v-model="seriesCardPrice"
        >
      </div>

      <div class="form-group">
        <label class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.series_edit.share_level') }}
        </label>
        <div class="mt-6">
          <ToggleSwitch v-on:change="toggleShareLevel" v-bind:model-value="seriesShareLevel" v-bind:check-value="1" id="share-level-switch">
            <span slot="label">{{ getShareLevelLabel(seriesShareLevel || 2) }}</span>
          </ToggleSwitch>
        </div>
      </div>


    </div>
  </CustomModal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { isNil } from 'lodash';
  import labels from '@/mixins/labels';

  export default {
    name: 'series-edit-modal',

    mixins: [
      labels,
    ],

    props: {
      seriesItem: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        seriesPrice: null,
        seriesCardPrice: null,
        seriesTitle: '',
        seriesShareLevel: 0,
        busy: false,
      };
    },

    computed: {
      ...mapGetters([
        'chapterCardList',
      ]),

      saveDisabled() {
        if (!isNil(this.seriesItem)) {
          return (this.seriesPrice === this.seriesItem.price &&
            this.seriesCardPrice === this.seriesItem.card_price &&
            this.seriesShareLevel === this.seriesItem.share_level &&
            this.seriesTitle === this.seriesItem.name);
        }

        return true;
      },
    },

    methods: {
      ...mapActions([
        'setChapterCards',
        'updateSeries',
      ]),

      toggleShareLevel(value) {
        this.seriesShareLevel = (value ? 1 : 2);
      },

      save() {
        if (!this.busy) {
          this.busy = true;
  
          const params = {
            ...this.seriesItem,
            name: this.seriesTitle,
            price: this.seriesPrice || null,
            card_price: this.seriesCardPrice || null,
            share_level: this.seriesShareLevel,
          };
  
          this.updateSeries(params)
            .then(() => {
              const updatedSeriesCards = this.chapterCardList.filter(card => (
                card.series_id === this.seriesItem.id
              ))
              .map(card => ({
                ...card,
                price: this.seriesCardPrice || null,
                share_level: this.seriesShareLevel,
              }));

              return this.setChapterCards(updatedSeriesCards);
            })
            .then(() => (
              this.$emit('ok')
            ));
        }
      },
    },

    beforeMount() {
      this.loading = true;

      if (!isNil(this.seriesItem)) {
        this.seriesPrice = this.seriesItem.price;
        this.seriesCardPrice = this.seriesItem.card_price;
        this.seriesShareLevel = this.seriesItem.share_level;
        this.seriesTitle = this.seriesItem.name;
      }

      this.loading = false;
    },
  };
</script>

<style lang="scss">
  .series-edit-modal {
    .series-edit-modal__form {
      .form-group>.form-control {
        height: 47px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/SeriesEditModal.vue